import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import DutyTypeBadge from './DutyTypeBadge';

/**
 * DutyTypeLegend - displays legend for duty type colors
 * @param {Array} dutyTypes - array of duty type objects from API
 */
const DutyTypeLegend = ({ dutyTypes = [] }) => {
  if (!dutyTypes.length) return null;

  return (
    <Paper sx={{ p: 2, mt: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Chú thích:
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {dutyTypes.map((dutyType) => (
          <DutyTypeBadge key={dutyType.id} dutyType={dutyType} size="small" />
        ))}
      </Box>
    </Paper>
  );
};

export default DutyTypeLegend;
